// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-tcgkl{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.assets-scss-gridstyleGrid-grid-flhxe{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-kpzmx{grid-column:span 6}.assets-scss-gridstyleGrid-col3-jinqx{grid-column:span 3}.assets-scss-gridstyleGrid-col4-biddw{grid-column:span 4}.assets-scss-gridstyleGrid-col9-hjuso{grid-column:span 9}.assets-scss-gridstyleGrid-col12-bkhnt{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-bvuwd{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-tcgkl",
	"grid": "assets-scss-gridstyleGrid-grid-flhxe",
	"col6": "assets-scss-gridstyleGrid-col6-kpzmx",
	"col3": "assets-scss-gridstyleGrid-col3-jinqx",
	"col4": "assets-scss-gridstyleGrid-col4-biddw",
	"col9": "assets-scss-gridstyleGrid-col9-hjuso",
	"col12": "assets-scss-gridstyleGrid-col12-bkhnt",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-bvuwd"
};
module.exports = ___CSS_LOADER_EXPORT___;
